import React from 'react';
import { Redirect } from 'react-router-dom';

import ShutterbugMasterView from '../views/ShutterbugMasterView';
import ReservationView from '../views/Reservation';
import LoginView from '../views/Login';
import RedirectWithStatus from '../../../components/routing/RedirectWithStatus';
import Registration from '../views/Registration';
import RequireUnauth from '../../../components/routing/RequireUnauth';
import WeddingsRegistration from '../views/WeddingsRegistration';
import WeddingsGift from '../views/WeddingsGift';
import WeddingsGiftConfigure from '../views/WeddingsGiftConfigure';

const routes = [
  {
    path: '/shutterbug',
    exact: false,
    component: ShutterbugMasterView,
    routes: [
      {
        path: '/shutterbug/login',
        exact: true,
        component: () => (
          <RedirectWithStatus to="/shutterbug/signin" status={301} />
        ),
      },
      {
        path: '/shutterbug/reservation',
        exact: true,
        component: ReservationView,
      },
      {
        path: '/shutterbug/signup',
        exact: true,
        component: () => <Redirect to="/shutterbug/register" />,
      },
      {
        path: '/shutterbug/register/:plan?',
        exact: true,
        component: RequireUnauth(Registration),
      },
      {
        path: '/shutterbug/weddings/register',
        exact: true,
        component: WeddingsRegistration,
      },
      {
        path: '/shutterbug/weddings/gift',
        exact: true,
        component: WeddingsGift,
      },
      {
        path: '/shutterbug/weddings/gift/configure',
        exact: true,
        component: WeddingsGiftConfigure,
      },
      {
        path: '/shutterbug/signin',
        exact: true,
        component: LoginView,
      },
      // TODO [shutterbug]: update later when we have a home/dashboard style page
      {
        path: '/shutterbug',
        exact: true,
        component: () => <Redirect to="/shutterbug/reservation" />,
      },
    ],
  },
];

export default routes;
